// Helpers do gravador: permissão do mic, mensagens de erro e fallback de blob.
// Isolado para o AudioRecorder ficar curto e um agente manter sem contexto.

export const MIC_AUDIO_CONSTRAINTS = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};

/** Mensagem amigável a partir de NotAllowedError / iframe / etc. */
export function micErrorMessage(error) {
  const name = error?.name || '';
  const msg = String(error?.message || error || '');

  if (name === 'NotAllowedError' || /Permission|denied|NotAllowed/i.test(msg)) {
    return 'Microfone bloqueado. Permita o acesso no navegador (e no iframe do Painel IA: allow="microphone").';
  }
  if (name === 'NotFoundError' || /Requested device not found/i.test(msg)) {
    return 'Nenhum microfone encontrado neste dispositivo.';
  }
  if (name === 'NotReadableError' || /track|Device in use/i.test(msg)) {
    return 'Microfone em uso por outro app. Feche e tente de novo.';
  }
  if (/cross-origin|iframe|secure context|getUserMedia/i.test(msg)) {
    return 'Gravação bloqueada no embed. Abra o Chatwoot direto ou libere o mic no iframe.';
  }
  if (/Conversion|Unsupported|decodeAudioData/i.test(msg)) {
    return 'Não foi possível converter o áudio. Tente gravar de novo (Chrome/Edge).';
  }
  return 'Falha ao gravar áudio. Verifique o microfone e tente novamente.';
}

/** Pede permissão explícita antes do WaveSurfer (melhor UX no iframe). */
export async function ensureMicrophoneAccess() {
  if (!window.isSecureContext) {
    throw new Error('getUserMedia requires a secure context (HTTPS)');
  }
  if (!navigator?.mediaDevices?.getUserMedia) {
    throw new Error('getUserMedia is not supported in this browser');
  }

  const stream = await navigator.mediaDevices.getUserMedia({
    audio: MIC_AUDIO_CONSTRAINTS,
    video: false,
  });
  // Só validamos permissão; o RecordPlugin abre o stream dele.
  stream.getTracks().forEach(track => track.stop());
  return true;
}

/** Se a conversão MP3 falhar, envia o blob original (webm/ogg) em vez de descartar. */
export function fallbackRecordedFile(blob, uuid) {
  const type = blob?.type || 'audio/webm';
  let ext = 'webm';
  if (type.includes('ogg')) ext = 'ogg';
  else if (type.includes('mp4')) ext = 'm4a';
  const file = new File([blob], `${uuid}.${ext}`, { type });
  return {
    name: file.name,
    type: file.type,
    size: file.size,
    file,
  };
}
